export default {
  APP_ELEMENT_SELECTOR: '#app',
};
